import React from 'react'
import { Box } from '@mui/material'

import BaseInfoAutocomplete from './BaseInfoAutocomplete'
import {
  STORE_RELATION_FORM_BASE_INFO_AUTOCOMPLETE_CONFIG,
  STORE_RELATION_FORM_BASE_INFO_GRID_SX,
  STORE_RELATION_FORM_TEXT
} from '../constants/storeRelationFormConstants'

const StoreRelationBaseInfoSection = ({
  shouldRenderReadOnlyBaseInfo = false,
  readOnlyOptions,
  formState,
  supplierOptionsState,
  buyerOptionsState,
  referenceOptionsState,
  clientOptionsState,
  isClientStepCompleted = false,
  showValidationErrors = false,
  onSupplierChange,
  onBuyerChange,
  onReferenceChange,
  onClientChange,
  onSearchChange
}) => {
  const readOnlyFields = [
    {
      key: 'supplier',
      label: STORE_RELATION_FORM_BASE_INFO_AUTOCOMPLETE_CONFIG.suppliers.label,
      value: readOnlyOptions?.supplier
    },
    {
      key: 'buyer',
      label: STORE_RELATION_FORM_BASE_INFO_AUTOCOMPLETE_CONFIG.buyers.label,
      value: readOnlyOptions?.buyer
    },
    {
      key: 'reference',
      label: STORE_RELATION_FORM_BASE_INFO_AUTOCOMPLETE_CONFIG.references.label,
      value: readOnlyOptions?.reference
    },
    {
      key: 'client',
      label: STORE_RELATION_FORM_BASE_INFO_AUTOCOMPLETE_CONFIG.clients.label,
      value: readOnlyOptions?.client
    }
  ]

  return (
    <div className="store-relations-form__section">
      <h4 className="store-relations-form__section-title">{STORE_RELATION_FORM_TEXT.BASE_INFO_SECTION_TITLE}</h4>
      <p className="store-relations-form__section-text">
        {STORE_RELATION_FORM_TEXT.BASE_INFO_SECTION_TEXT}
      </p>

      <Box sx={STORE_RELATION_FORM_BASE_INFO_GRID_SX}>
        {shouldRenderReadOnlyBaseInfo ? (
          readOnlyFields.map((field) => (
            <BaseInfoAutocomplete
              key={field.key}
              label={field.label}
              options={field.value ? [field.value] : []}
              value={field.value}
              inputValue={field.value?.label || ''}
              disabled
              sx={{ minWidth: 0 }}
            />
          ))
        ) : (
          <>
            <BaseInfoAutocomplete
              label={STORE_RELATION_FORM_BASE_INFO_AUTOCOMPLETE_CONFIG.suppliers.label}
              options={supplierOptionsState.options}
              loading={supplierOptionsState.loading}
              value={formState.supplierOption}
              inputValue={formState.supplierSearch}
              onLoadMore={supplierOptionsState.loadMore}
              onChange={onSupplierChange}
              onInputChange={(_, nextInputValue, reason) => {
                if (reason === 'reset') return

                onSearchChange('supplierSearch', nextInputValue)
              }}
            />

            <BaseInfoAutocomplete
              label={STORE_RELATION_FORM_BASE_INFO_AUTOCOMPLETE_CONFIG.buyers.label}
              disabled={!formState.supplierOption?.value}
              options={buyerOptionsState.options}
              loading={buyerOptionsState.loading}
              value={formState.buyerOption}
              inputValue={formState.buyerSearch}
              onLoadMore={buyerOptionsState.loadMore}
              onChange={onBuyerChange}
              onInputChange={(_, nextInputValue, reason) => {
                if (reason === 'reset') return

                onSearchChange('buyerSearch', nextInputValue)
              }}
            />

            <BaseInfoAutocomplete
              label={STORE_RELATION_FORM_BASE_INFO_AUTOCOMPLETE_CONFIG.references.label}
              disabled={!formState.supplierOption?.value || !formState.buyerOption?.value}
              options={referenceOptionsState.options}
              loading={referenceOptionsState.loading}
              value={formState.referenceOption}
              inputValue={formState.referenceSearch}
              onLoadMore={referenceOptionsState.loadMore}
              onChange={onReferenceChange}
              onInputChange={(_, nextInputValue, reason) => {
                if (reason === 'reset') return

                onSearchChange('referenceSearch', nextInputValue)
              }}
            />

            <BaseInfoAutocomplete
              label={STORE_RELATION_FORM_BASE_INFO_AUTOCOMPLETE_CONFIG.clients.label}
              disabled={!formState.supplierOption?.value || !formState.buyerOption?.value || !formState.referenceOption?.value}
              required
              error={showValidationErrors && !isClientStepCompleted}
              helperText={showValidationErrors && !isClientStepCompleted
                ? STORE_RELATION_FORM_TEXT.CLIENT_REQUIRED
                : ''}
              options={clientOptionsState.options}
              loading={clientOptionsState.loading}
              value={formState.clientOption}
              inputValue={formState.clientSearch}
              onLoadMore={clientOptionsState.loadMore}
              onChange={onClientChange}
              onInputChange={(_, nextInputValue, reason) => {
                if (reason === 'reset') return

                onSearchChange('clientSearch', nextInputValue)
              }}
            />
          </>
        )}
      </Box>
    </div>
  )
}

export default StoreRelationBaseInfoSection
